<div class="content-wrapper-inner">
  <div class="page-content">
    <div class="mb-20">
      <app-callback-history-filter (onSubmit)="onFilter($event)"></app-callback-history-filter>
    </div>
    <div class="pos-relative">
      <app-callback-history-table (changeBatch)="selectedRows = $event"></app-callback-history-table>
      <div class="table-action-info-bar" *ngIf="selectedRows.length">
        <div class="info-left">
          <div class="text-icon-holder" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{selectedRows.length}} Selected</span>
          </div>
        </div>
        <div class="info-right">
        </div>
      </div>
    </div>
  </div>
</div>
